import * as React from "react";

export function TevIcon(props: React.SVGProps<SVGSVGElement>) {
  const color = props.color || "currentColor";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 36.122 37.325" {...props}>
      <g transform="translate(-27.129 -27.444)">
        <path fill="none" d="M5 5h582v402H5z" />
      </g>
      <g transform="matrix(.05008 0 0 .05008 -21.222 224.926)">
        <path
          d="M894.195-4483.84l-302.65 293.79 163.14 5.429-258.85 245.12 109.64 1.95-181.67 191.23 438.95-233.26-163.39 1.64 330.74-251.65-178.91-.42 293.96-261.68-250.96 7.846z"
          fillRule="evenodd"
          fill={color}
        />
      </g>
    </svg>
  );
}
